(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAbout(root){
    if(root.dataset.auInit) return;
    root.dataset.auInit = '1';
    var track = root.querySelector('.au-track');
    if(!track) return;
    var prev = root.querySelector('.au-prev');
    var next = root.querySelector('.au-next');

    function step(){
      var card = track.querySelector('.au-card');
      return card ? card.getBoundingClientRect().width + 22 : track.clientWidth * 0.8;
    }
    if(next) next.addEventListener('click', function(){ track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if(prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); });

    function update(){
      var max = track.scrollWidth - track.clientWidth - 2;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= max;
      track.classList.toggle('at-start', atStart);
      track.classList.toggle('at-end', atEnd);
      if(prev) prev.disabled = atStart;
      if(next) next.disabled = atEnd;
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    // drag-to-scroll for mouse users
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('pointerdown', function(e){
      if(e.pointerType === 'touch') return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      track.setPointerCapture(e.pointerId); track.style.cursor = 'grabbing';
    });
    track.addEventListener('pointermove', function(e){
      if(!down) return;
      var dx = e.clientX - startX;
      if(Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startLeft - dx;
    });
    function end(){ if(!down) return; down = false; track.style.cursor = ''; }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); } }, true);
  }
  function all(ctx){ (ctx || document).querySelectorAll('.au-root').forEach(initAbout); }
  if(document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', function(){ all(); });
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header-fabel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHeader(hd){
    if(hd.dataset.hd2Init) return;
    hd.dataset.hd2Init = '1';

    // hysteresis so the morph doesn't flicker at the threshold
    function onScroll(){
      var y = window.scrollY || window.pageYOffset;
      if(y > 24) hd.classList.add('scrolled');
      else if(y < 8) hd.classList.remove('scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // nothing moves horizontally anymore; the only measured value is the
    // logo scale needed to clear the 60px pill interior when scrolled
    var logoEl = hd.querySelector('.hd2-logo');
    function setScale(){
      if(!logoEl) return;
      var lh = logoEl.offsetHeight || 0;
      var sc = lh > 0 ? Math.min(0.92, 42 / lh) : 0.92;
      hd.style.setProperty('--hd2-logo-scale', sc.toFixed(3));
    }
    setScale();
    window.addEventListener('resize', setScale);
    window.addEventListener('load', setScale); /* logo image dimensions */

    // current-page fallback: Liquid's link.current only matches exact URLs,
    // so it misses query params and subpaths. Match by pathname here.
    function markCurrent(){
      var here = location.pathname.replace(/\/+$/, '') || '/';
      hd.querySelectorAll('.hd2-link, .hd2-sublink, .hd2-panel-link, .hd2-panel-sub').forEach(function(a){
        var path = a.pathname ? (a.pathname.replace(/\/+$/, '') || '/') : '';
        if(path && path === here){
          a.classList.add('is-current');
          if(a.getAttribute('aria-current') !== 'page') a.setAttribute('aria-current', 'page');
          var item = a.closest('.hd2-item');
          if(item){
            var parent = item.querySelector('.hd2-link');
            if(parent) parent.classList.add('is-current');
          }
        }
      });
    }
    markCurrent();

    var burger = hd.querySelector('.hd2-burger');
    var panel = hd.querySelector('.hd2-panel');
    function setMenu(open){
      hd.classList.toggle('menu-open', open);
      if(burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    if(burger) burger.addEventListener('click', function(){ setMenu(!hd.classList.contains('menu-open')); });
    if(panel) panel.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ setMenu(false); }); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') setMenu(false); });
    window.addEventListener('resize', function(){ if(window.innerWidth > 840) setMenu(false); });
  }
  function all(ctx){ (ctx || document).querySelectorAll('.hd2').forEach(initHeader); }
  if(document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', function(){ all(); });
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });

  /* ============================================================
     ADD-TO-CART CELEBRATION
     No universal Shopify event exists for ajax cart adds, so we
     watch the network: any successful fetch/XHR to /cart/add
     triggers the animation and refreshes the badge from /cart.js.
     Also listens for a manual 'cart:added' document event so any
     future code can trigger it directly.
     ============================================================ */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function refreshCount(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){
        if(!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
        return cart.item_count;
      })
      .catch(function(){});
  }

  function retrigger(el, cls){
    el.classList.remove(cls);
    void el.offsetWidth; /* restart the animation on rapid adds */
    el.classList.add(cls);
  }

  /* brand confetti: accent blues + kraft, tiny sticker squares and dots,
     each on its own gravity arc via the Web Animations API */
  var CONFETTI_COLORS = ['#1b4dff', '#4a77ff', '#123bcf', '#e0dcd0'];
  function burstConfetti(cartEl){
    if(!Element.prototype.animate) return; /* WAAPI missing: skip, no fallback needed */
    var COUNT = 14;
    for(var i = 0; i < COUNT; i++){
      var bit = document.createElement('span');
      var chip = Math.random() > 0.4;
      bit.className = 'hd2-confetti ' + (chip ? 'is-chip' : 'is-dot');
      bit.style.background = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      var size = 4 + Math.random() * 5;
      bit.style.width = size + 'px';
      bit.style.height = (chip ? size * 0.72 : size) + 'px';
      cartEl.appendChild(bit);

      /* launch mostly upward in a fan, then gravity pulls the arc down */
      var angle = (-90 + (Math.random() * 140 - 70)) * Math.PI / 180;
      var velocity = 34 + Math.random() * 30;
      var dx = Math.cos(angle) * velocity;
      var dy = Math.sin(angle) * velocity;
      var drop = 34 + Math.random() * 22;
      var spin = (Math.random() * 2 - 1) * 540;
      var dur = 650 + Math.random() * 350;

      var anim = bit.animate([
        { transform: 'translate(-50%,-50%) translate(0,0) rotate(0deg) scale(1)', opacity: 1 },
        { transform: 'translate(-50%,-50%) translate(' + dx + 'px,' + dy + 'px) rotate(' + (spin/2) + 'deg) scale(1)', opacity: 1, offset: 0.45 },
        { transform: 'translate(-50%,-50%) translate(' + (dx * 1.35) + 'px,' + (dy + drop) + 'px) rotate(' + spin + 'deg) scale(.6)', opacity: 0 }
      ], { duration: dur, easing: 'cubic-bezier(.16,.6,.4,1)', fill: 'forwards' });
      anim.onfinish = (function(el){ return function(){ el.remove(); }; })(bit);
    }
  }

  function celebrate(){
    refreshCount();
    if(reduceMotion) return; /* count still updates, no theatrics */
    document.querySelectorAll('.hd2-cart').forEach(function(cartEl){
      retrigger(cartEl, 'cart-bump');
      var badge = cartEl.querySelector('[data-cart-count]');
      if(badge) retrigger(badge, 'count-pop');
      cartEl.querySelectorAll('.hd2-confetti').forEach(function(b){ b.remove(); });
      burstConfetti(cartEl);
    });
  }

  function isCartAdd(url){
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  /* fetch interception — covers the bag builder and most ajax carts */
  if(window.fetch && !window.__hd2CartWatch){
    window.__hd2CartWatch = true;
    var origFetch = window.fetch;
    window.fetch = function(input, init){
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if(isCartAdd(url)){
        p.then(function(res){ if(res && res.ok) celebrate(); }).catch(function(){});
      }
      return p;
    };

    /* XHR interception — covers older cart scripts */
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url){
      this.__hdCartAdd = isCartAdd(url);
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function(){
      if(this.__hdCartAdd){
        this.addEventListener('load', function(){
          if(this.status >= 200 && this.status < 300) celebrate();
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  /* manual hook: document.dispatchEvent(new CustomEvent('cart:added')) */
  document.addEventListener('cart:added', celebrate);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHeader(hd){
    if(hd.dataset.hdInit) return;
    hd.dataset.hdInit = '1';

    // Sticky builder: an Easy Mode visitor should keep landing on Easy, even
    // from the header's "custom" menu link (which points at the default builder
    // URL set in Navigation). Each builder page stamps sm_last_builder; if it
    // says Easy, repoint any nav link whose href matches the default builder URL
    // to the Easy URL. Match by pathname so it survives menu reordering and
    // query strings, and only ever swap between the two KNOWN builder URLs.
    (function(){
      try {
        var easyU = (hd.getAttribute('data-hd-easy')    || '').trim();
        var bldrU = (hd.getAttribute('data-hd-builder') || '').trim();
        if(!easyU || !bldrU) return;                 // both must be configured
        var last = '';
        try { last = localStorage.getItem('sm_last_builder') || ''; } catch(e){}
        function pathOf(u){ try { return new URL(u, window.location.origin).pathname.replace(/\/$/,''); } catch(e){ return ''; } }
        if(pathOf(last) !== pathOf(easyU)) return;   // only act for Easy-bucket visitors
        var bldrPath = pathOf(bldrU);
        hd.querySelectorAll('a[href]').forEach(function(a){
          if(pathOf(a.getAttribute('href')) === bldrPath) a.setAttribute('href', easyU);
        });
      } catch(e){}
    })();

    // hysteresis so the morph doesn't flicker at the threshold
    function onScroll(){
      var y = window.scrollY || window.pageYOffset;
      if(y > 24) hd.classList.add('scrolled');
      else if(y < 8) hd.classList.remove('scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var burger = hd.querySelector('.hd-burger');
    var panel = hd.querySelector('.hd-panel');
    function setMenu(open){
      hd.classList.toggle('menu-open', open);
      if(burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    if(burger) burger.addEventListener('click', function(){ setMenu(!hd.classList.contains('menu-open')); });
    if(panel) panel.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ setMenu(false); }); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') setMenu(false); });
    window.addEventListener('resize', function(){ if(window.innerWidth > 840) setMenu(false); });
  }
  function all(ctx){ (ctx || document).querySelectorAll('.hd').forEach(initHeader); }
  if(document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', function(){ all(); });
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-headerv2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHeader(hd){
    if(hd.dataset.hdInit) return;
    hd.dataset.hdInit = '1';

    // hysteresis so the morph doesn't flicker at the threshold
    function onScroll(){
      var y = window.scrollY || window.pageYOffset;
      if(y > 24) hd.classList.add('scrolled');
      else if(y < 8) hd.classList.remove('scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var burger = hd.querySelector('.hd-burger');
    var panel = hd.querySelector('.hd-panel');
    function setMenu(open){
      hd.classList.toggle('menu-open', open);
      if(burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    if(burger) burger.addEventListener('click', function(){ setMenu(!hd.classList.contains('menu-open')); });
    if(panel) panel.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ setMenu(false); }); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') setMenu(false); });
    window.addEventListener('resize', function(){ if(window.innerWidth > 840) setMenu(false); });
  }

  // Current-page marking is separate from initHeader's one-shot guard on
  // purpose: it must be re-runnable whenever the header DOM is re-rendered
  // (Shopify section reloads, theme nav swaps). Idempotent — safe to call
  // repeatedly.
  function markCurrent(hd){
    var here = location.pathname.replace(/\/+$/, '') || '/';
    hd.querySelectorAll('.hd-link, .hd-sublink, .hd-panel-link, .hd-panel-sub').forEach(function(a){
      var path = a.pathname ? (a.pathname.replace(/\/+$/, '') || '/') : '';
      var on = !!path && path === here;
      a.classList.toggle('is-current', on);
      if(on){
        if(a.getAttribute('aria-current') !== 'page') a.setAttribute('aria-current', 'page');
        var item = a.closest('.hd-item');
        if(item){ var parent = item.querySelector('.hd-link'); if(parent) parent.classList.add('is-current'); }
      } else if(a.getAttribute('aria-current') === 'page'){
        a.removeAttribute('aria-current');
      }
    });
  }
  function all(ctx){ (ctx || document).querySelectorAll('.hd').forEach(initHeader); }
  function markAll(ctx){ (ctx || document).querySelectorAll('.hd').forEach(markCurrent); }
  function boot(){ all(); markAll(); }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  // re-mark after full load and on section reloads: covers the case where the
  // header DOM is present at init but gets re-rendered afterward, which was
  // wiping the class the one-shot init had set.
  window.addEventListener('load', function(){ markAll(); });
  document.addEventListener('shopify:section:load', function(e){ all(e.target); markAll(e.target); });

  /* ============================================================
     ADD-TO-CART CELEBRATION
     No universal Shopify event exists for ajax cart adds, so watch the
     network: any successful fetch/XHR to /cart/add triggers the animation
     and refreshes the badge from /cart.js. A manual 'cart:added' document
     event is also honored for code that bypasses those endpoints.
     ============================================================ */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CONFETTI_COLORS = ['#1b4dff', '#4a77ff', '#123bcf', '#e0dcd0'];

  function refreshCount(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){
        if(!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      }).catch(function(){});
  }

  function retrigger(el, cls){ el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }

  function burstConfetti(cartEl){
    if(!Element.prototype.animate) return;
    for(var i = 0; i < 14; i++){
      var bit = document.createElement('span');
      var chip = Math.random() > 0.4;
      bit.className = 'hd-confetti ' + (chip ? 'is-chip' : 'is-dot');
      bit.style.background = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      var size = 4 + Math.random() * 5;
      bit.style.width = size + 'px';
      bit.style.height = (chip ? size * 0.72 : size) + 'px';
      cartEl.appendChild(bit);
      var angle = (-90 + (Math.random() * 140 - 70)) * Math.PI / 180;
      var vel = 34 + Math.random() * 30;
      var dx = Math.cos(angle) * vel, dy = Math.sin(angle) * vel;
      var drop = 34 + Math.random() * 22;
      var spin = (Math.random() * 2 - 1) * 540;
      var dur = 650 + Math.random() * 350;
      var anim = bit.animate([
        { transform: 'translate(-50%,-50%) translate(0,0) rotate(0deg) scale(1)', opacity: 1 },
        { transform: 'translate(-50%,-50%) translate(' + dx + 'px,' + dy + 'px) rotate(' + (spin/2) + 'deg) scale(1)', opacity: 1, offset: 0.45 },
        { transform: 'translate(-50%,-50%) translate(' + (dx*1.35) + 'px,' + (dy+drop) + 'px) rotate(' + spin + 'deg) scale(.6)', opacity: 0 }
      ], { duration: dur, easing: 'cubic-bezier(.16,.6,.4,1)', fill: 'forwards' });
      anim.onfinish = (function(el){ return function(){ el.remove(); }; })(bit);
    }
  }

  function celebrate(){
    refreshCount();
    if(reduceMotion) return;
    document.querySelectorAll('.hd-cart').forEach(function(cartEl){
      retrigger(cartEl, 'cart-bump');
      var badge = cartEl.querySelector('[data-cart-count]');
      if(badge) retrigger(badge, 'count-pop');
      cartEl.querySelectorAll('.hd-confetti').forEach(function(b){ b.remove(); });
      burstConfetti(cartEl);
    });
  }

  function isCartAdd(url){ return typeof url === 'string' && url.indexOf('/cart/add') !== -1; }

  if(window.fetch && !window.__hdCartWatch){
    window.__hdCartWatch = true;
    var origFetch = window.fetch;
    window.fetch = function(input){
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if(isCartAdd(url)){ p.then(function(res){ if(res && res.ok) celebrate(); }).catch(function(){}); }
      return p;
    };
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url){ this.__hdCartAdd = isCartAdd(url); return origOpen.apply(this, arguments); };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function(){
      if(this.__hdCartAdd){ this.addEventListener('load', function(){ if(this.status >= 200 && this.status < 300) celebrate(); }); }
      return origSend.apply(this, arguments);
    };
  }
  document.addEventListener('cart:added', celebrate);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initFaq(root){
    if(root.dataset.faqInit) return;
    root.dataset.faqInit = '1';
    root.querySelectorAll('.faq-q').forEach(function(btn){
      btn.addEventListener('click', function(){
        var item = btn.closest('.faq-item');
        var open = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  function all(ctx){ (ctx || document).querySelectorAll('.faq-root').forEach(initFaq); }
  if(document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', function(){ all(); });
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premade-scroller"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initTile(tile){
    var glare = tile.querySelector('.pms-glare');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    tile.addEventListener('mouseenter', function(){ tile.classList.add('lift'); tile.style.zIndex = '30'; });
    tile.addEventListener('mousemove', function(e){
      var r = tile.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      if (reduce){ tile.style.transform = 'scale(1.1)'; return; }
      var rx = (0.5 - py) * 22, ry = (px - 0.5) * 22;
      tile.style.transform = 'perspective(640px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(1.16) translateY(-6px)';
      if (glare) glare.style.background = 'radial-gradient(circle at ' + (px*100).toFixed(1) + '% ' + (py*100).toFixed(1) + '%, rgba(255,255,255,.5), rgba(255,255,255,0) 50%)';
    });
    tile.addEventListener('mouseleave', function(){ tile.classList.remove('lift'); tile.style.zIndex = ''; tile.style.transform = ''; if (glare) glare.style.background = ''; });
  }
  function initRoot(root){
    if (!root || root.dataset.pmsInit) return;
    root.dataset.pmsInit = '1';
    // duplicate each row's contents so the loop is seamless
    root.querySelectorAll('.pms-row').forEach(function(row){ row.innerHTML = row.innerHTML + row.innerHTML; });
    // attach tilt to every tile (originals + clones)
    root.querySelectorAll('.pms-tile').forEach(initTile);
  }
  function initAll(ctx){ (ctx || document).querySelectorAll('.pms-root').forEach(initRoot); }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  // re-init when added/edited in the Theme Editor
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premade-scrollerv2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initTile(tile){
    // No hover on touch devices — synthetic mouse events from taps/drags were
    // firing the tilt handler and scaling tiles mid-scroll.
    if (window.matchMedia('(hover: none)').matches) return;
    var glare = tile.querySelector('.pms-glare');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    tile.addEventListener('mouseenter', function(){ tile.classList.add('lift'); tile.style.zIndex = '30'; });
    tile.addEventListener('mousemove', function(e){
      var r = tile.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      if (reduce){ tile.style.transform = 'scale(1.1)'; return; }
      var rx = (0.5 - py) * 22, ry = (px - 0.5) * 22;
      tile.style.transform = 'perspective(640px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(1.10) translateY(-6px)';
      if (glare) glare.style.background = 'radial-gradient(circle at ' + (px*100).toFixed(1) + '% ' + (py*100).toFixed(1) + '%, rgba(255,255,255,.5), rgba(255,255,255,0) 50%)';
    });
    tile.addEventListener('mouseleave', function(){ tile.classList.remove('lift'); tile.style.zIndex = ''; tile.style.transform = ''; if (glare) glare.style.background = ''; });
  }

  // Clone each row's original tiles enough times that HALF the row is always
  // wider than the viewport — that's what keeps the -50% loop seamless with no gap.
  function fillRow(row){
    if (!row._pmsOrig){ row._pmsOrig = row.innerHTML; }
    var original = row._pmsOrig;
    row.innerHTML = original;                 // one set, to measure
    var setWidth = row.scrollWidth;
    var target = Math.max(window.innerWidth || 0, 1920) * 2 + 600;
    var copies = 2;
    if (setWidth > 0){
      copies = Math.ceil(target / setWidth);
      if (copies < 2) copies = 2;
      if (copies % 2 !== 0) copies += 1;       // must be even so -50% lands on a seam
    }
    var html = '';
    for (var i = 0; i < copies; i++){ html += original; }
    row.innerHTML = html;
    row.querySelectorAll('.pms-tile').forEach(initTile);
  }

  // Mobile marquee: auto-advance scrollLeft; touching pauses; user swipes
  // natively both ways; resumes ~2s after the last interaction. Wrapping by
  // half the row is seamless because fillRow always builds an EVEN number of
  // copies, so half is a content seam.
  var pmsMq = window.matchMedia('(max-width:767px)');
  function initMobileRow(row){
    if (row._pmsMob) return;
    row._pmsMob = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dir = row.classList.contains('b') ? -1 : 1;
    var paused = false, idleT = null, last = null;
    var SPEED = 32; // px per second
    var pos = null; // float position — Safari quantizes scrollLeft to ints,
                    // so sub-pixel per-frame increments must accumulate here

    function half(){ return row.scrollWidth / 2; }
    function wrap(){
      var h = half();
      if (h <= 0) return;
      if (row.scrollLeft >= h * 1.5){ row.scrollLeft -= h; pos = row.scrollLeft; }
      else if (row.scrollLeft < h * 0.5){ row.scrollLeft += h; pos = row.scrollLeft; }
    }
    function center(){ if (pmsMq.matches){ row.scrollLeft = half(); pos = row.scrollLeft; } }
    function pause(){ paused = true; clearTimeout(idleT); }
    function queueResume(){
      if (reduce) return;
      clearTimeout(idleT);
      idleT = setTimeout(function(){ paused = false; last = null; pos = row.scrollLeft; }, 2000);
    }

    row.addEventListener('touchstart', pause, { passive: true });
    row.addEventListener('touchend', queueResume, { passive: true });
    row.addEventListener('touchcancel', queueResume, { passive: true });
    row.addEventListener('scroll', function(){
      if (paused) queueResume(); // momentum keeps pushing the resume timer
      wrap();
    }, { passive: true });

    if (!reduce){
      function tick(ts){
        if (!row.isConnected) return;
        if (!paused && pmsMq.matches){
          if (last != null){
            var dt = Math.min(ts - last, 48);
            if (pos == null) pos = row.scrollLeft;
            pos += dir * (dt / 1000) * SPEED;
            row.scrollLeft = pos;
            wrap();
          }
          last = ts;
        } else {
          last = null;
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    center();
    if (pmsMq.addEventListener){ pmsMq.addEventListener('change', function(e){ if (e.matches) center(); }); }
  }

  function initRoot(root){
    if (!root || root.dataset.pmsInit) return;
    root.dataset.pmsInit = '1';
    root.querySelectorAll('.pms-row').forEach(fillRow);
    root.querySelectorAll('.pms-row').forEach(initMobileRow);
    var t;
    window.addEventListener('resize', function(){
      clearTimeout(t);
      t = setTimeout(function(){
        root.querySelectorAll('.pms-row').forEach(function(row){
          if (row.scrollWidth / 2 < (window.innerWidth || 0) + 60){ fillRow(row); }
        });
      }, 250);
    });
  }
  function initAll(ctx){ (ctx || document).querySelectorAll('.pms-root').forEach(initRoot); }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function headerHeight(){
    // This header is position:fixed and reserves space via body{padding-top}.
    // The fixed bar has no flow height to measure, so cancel the body padding instead.
    var pt = parseFloat(getComputedStyle(document.body).paddingTop) || 0;
    if(pt > 0) return pt;
    var el = document.querySelector('.hd, header[role="banner"], .site-header, .header-wrapper');
    return el ? el.offsetHeight : 0;
  }
  function applyUnderHeader(root){
    var wrap = root.closest('.shopify-section') || root.parentElement;
    if(!wrap) return;
    function go(){
      var h = headerHeight();
      if(h>0){
        wrap.style.marginTop = (-h)+'px';
      }
    }
    go();
    window.addEventListener('resize', go);
    setTimeout(go, 300);
  }
  function loopyPath(S, E, flip){
    var dx = E.x - S.x, dy = E.y - S.y;
    function tp(nx, ny){
      ny = ny * flip + (Math.random()-0.5)*0.025;
      nx = nx + (Math.random()-0.5)*0.018;
      return (S.x + nx*dx + ny*(-dy)).toFixed(1) + ' ' + (S.y + nx*dy + ny*(dx)).toFixed(1);
    }
    var segs = [
      [0.08,-0.16, 0.22,-0.20, 0.30,-0.06],
      [0.36,0.04,  0.30,0.16,  0.18,0.12],
      [0.08,0.09,  0.10,-0.04, 0.24,-0.03],
      [0.45,-0.02, 0.62,-0.10, 0.80,-0.06],
      [0.88,-0.04, 0.94,-0.02, 1.0,0.0]
    ];
    var d = 'M ' + tp(0,0);
    segs.forEach(function(s){ d += ' C ' + tp(s[0],s[1]) + ' ' + tp(s[2],s[3]) + ' ' + tp(s[4],s[5]); });
    var ang = Math.atan2(dy, dx);
    var ah = Math.min(17, Math.hypot(dx,dy)*0.16);
    function barb(sp){ var a = ang + Math.PI + sp; return (E.x + ah*Math.cos(a)).toFixed(1)+' '+(E.y + ah*Math.sin(a)).toFixed(1); }
    d += ' M '+E.x.toFixed(1)+' '+E.y.toFixed(1)+' L '+barb(0.5);
    d += ' M '+E.x.toFixed(1)+' '+E.y.toFixed(1)+' L '+barb(-0.5);
    return d;
  }
  function setupDoodles(root){
    var wrap = root.querySelector('.vh-doodles');
    if(!wrap) return;
    var NS = 'http://www.w3.org/2000/svg';
    var svg = wrap.querySelector('.vh-doodle-svg');
    var lab1 = wrap.querySelector('[data-doodle="1"]');
    var lab2 = wrap.querySelector('[data-doodle="2"]');
    var btnP = root.querySelector('.vh-btn.primary');
    var btnS = root.querySelector('.vh-btn.secondary');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DRAW = 2100, HOLD = 2600, FADE = 1000, GAP = 350;
    var timers = [], idx = 0, rt = null;
    function clearTimers(){ timers.forEach(clearTimeout); timers = []; }
    function clearSvg(){ while(svg.firstChild) svg.removeChild(svg.firstChild); }

    function compute(){
      var cr = root.getBoundingClientRect(), W = cr.width, Hh = cr.height;
      if(W < 1024) return null;
      function rel(el){ var r=el.getBoundingClientRect(); return {x:r.left-cr.left,y:r.top-cr.top,w:r.width,h:r.height,b:r.bottom-cr.top,rgt:r.right-cr.left}; }
      var arr = [];
      if(btnP){ var p=rel(btnP); arr.push({ E:{x:p.x+p.w*0.35,y:p.b+4}, S:{x:Math.max(78,p.x-36),y:Math.min(Hh-46,p.b+98)}, flip:1, lab:lab1, rot:-7 }); }
      if(btnS){ var s=rel(btnS); arr.push({ E:{x:s.x+s.w*0.6,y:s.b+4}, S:{x:Math.min(W-90,s.rgt+66),y:Math.min(Hh-46,s.b+78)}, flip:-1, lab:lab2, rot:6 }); }
      return { W:W, Hh:Hh, arr:arr };
    }
    function placeLabel(it){
      if(!it.lab) return;
      it.lab.style.left = it.S.x+'px'; it.lab.style.top = (it.S.y+14)+'px';
      it.lab.style.setProperty('--rot', it.rot+'deg');
    }
    function showItem(it){
      clearSvg();
      if(lab1) lab1.classList.remove('show');
      if(lab2) lab2.classList.remove('show');
      var p = document.createElementNS(NS,'path');
      p.setAttribute('class','vh-arrow');
      p.setAttribute('d', loopyPath(it.S, it.E, it.flip));
      svg.appendChild(p); it.path = p;
      placeLabel(it);
      if(reduce){ if(it.lab) it.lab.classList.add('show'); return; }
      var len = p.getTotalLength();
      p.style.strokeDasharray = len; p.style.strokeDashoffset = len;
      p.getBoundingClientRect();
      p.style.transition = 'stroke-dashoffset ' + DRAW + 'ms ease';
      p.style.strokeDashoffset = '0';
      timers.push(setTimeout(function(){ if(it.lab) it.lab.classList.add('show'); }, DRAW * 0.45));
    }
    function hideItem(it){
      if(it.lab) it.lab.classList.remove('show');
      if(it.path){ var len = it.path.getTotalLength(); it.path.style.transition = 'stroke-dashoffset ' + FADE + 'ms ease'; it.path.style.strokeDashoffset = len; }
    }
    function run(){
      clearTimers();
      var data = compute();
      if(!data){ wrap.style.display = 'none'; return; }
      wrap.style.display = '';
      svg.setAttribute('width', data.W); svg.setAttribute('height', data.Hh);
      svg.setAttribute('viewBox', '0 0 ' + data.W + ' ' + data.Hh);
      var items = data.arr;
      if(!items.length) return;
      if(reduce){ items.forEach(function(it){ // static: draw all, no cycle
        var p=document.createElementNS(NS,'path'); p.setAttribute('class','vh-arrow'); p.setAttribute('d',loopyPath(it.S,it.E,it.flip)); svg.appendChild(p); placeLabel(it); if(it.lab) it.lab.classList.add('show');
      }); return; }
      function step(){
        var it = items[idx % items.length];
        showItem(it);
        timers.push(setTimeout(function(){
          hideItem(it);
          timers.push(setTimeout(function(){ idx++; step(); }, FADE + GAP));
        }, DRAW + HOLD));
      }
      step();
    }
    run();
    function deb(){ clearTimeout(rt); rt = setTimeout(run, 200); }
    if('ResizeObserver' in window){ new ResizeObserver(deb).observe(root); }
    window.addEventListener('resize', deb);
  }
  // A/B builder routing: point the custom button at whichever builder the visitor
  // last used (each builder page stamps its path into localStorage on load). Only
  // accept a stored value that matches one of the two known builder URLs, so a
  // stale/garbage value can never redirect somewhere unexpected. Progressive
  // enhancement — with no JS, the static href (Easy Mode by default) still works.
  function routeBuilder(root){
    try{
      var link = root.querySelector('[data-vh-custom]');
      if(!link) return;
      var last = '';
      try { last = localStorage.getItem('sm_last_builder') || ''; } catch(e){}
      var easyU = (link.getAttribute('data-vh-easy')    || '').trim();
      var bldrU = (link.getAttribute('data-vh-builder') || '').trim();
      function pathOf(u){ try { return new URL(u, window.location.origin).pathname.replace(/\/$/,''); } catch(e){ return ''; } }
      var lp = pathOf(last);
      if(lp && easyU && lp === pathOf(easyU))      link.setAttribute('href', easyU);
      else if(lp && bldrU && lp === pathOf(bldrU)) link.setAttribute('href', bldrU);
      // no/unknown stored value -> leave the static href untouched
    }catch(e){}
  }
  function setup(root){
    routeBuilder(root);
    if(root.getAttribute('data-under-header') === 'true'){ applyUnderHeader(root); }
    if(root.getAttribute('data-doodles') === 'true'){ setupDoodles(root); }
    var cue = root.querySelector('.vh-scroll');
    if(cue && !cue._wired){
      cue._wired = true;
      cue.addEventListener('click', function(){
        var sec = root.closest('.section-video-hero') || root.closest('section');
        var next = sec ? sec.nextElementSibling : null;
        if(next && next.scrollIntoView){ next.scrollIntoView({behavior:'smooth', block:'start'}); }
        else { window.scrollBy({top: Math.round(window.innerHeight*0.9), behavior:'smooth'}); }
      });
      var onScroll = function(){ cue.classList.toggle('hide', (window.scrollY || window.pageYOffset || 0) > 60); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    var v = root.querySelector('video.vh-video');
    if(!v) return;
    // Phones load the small mobile file instead of the desktop render.
    // Swap happens at init: any desktop bytes already in flight get aborted
    // by load(). Worst case (no JS) the desktop file plays — poster covers
    // the gap either way.
    var ms = v.getAttribute('data-mobile-sources');
    if(ms && !v._vhSwapped && window.matchMedia('(max-width:767px)').matches){
      v._vhSwapped = true;
      try{ v.pause(); }catch(e){}
      while(v.firstChild) v.removeChild(v.firstChild);
      ms.split(',').forEach(function(pair){
        var i = pair.lastIndexOf('|');
        if(i < 1) return;
        var s = document.createElement('source');
        s.src = pair.slice(0, i);
        s.type = pair.slice(i + 1);
        v.appendChild(s);
      });
      try{ v.load(); }catch(e){}
    }
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      v.removeAttribute('autoplay');
      try{ v.pause(); }catch(e){}
      return;
    }
    var p = v.play();
    if(p && p.catch){ p.catch(function(){}); }
  }
  function all(ctx){ (ctx || document).querySelectorAll('.vh-hero').forEach(setup); }
  if(document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', function(){ all(); });
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
